
// imports
import { PropiedadesComponent } from '../propiedades/propiedades.component';
import { SolicitanteComponent } from '../solicitante/solicitante.component';
import { Tipos_certificadosComponent } from '../tipos_certificados/tipos_certificados.component';
import { CorviComponent } from '../corvi/corvi.component';
import { Resumen_certComponent } from '../resumen_cert/resumen_cert.component';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FilterPipe3 } from 'src/app/pipes/filter.pipe3';




import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { NgxPaginationModule } from 'ngx-pagination';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { Tabs_certComponent } from '../tabs_cert/tabs_cert.component';
import { PortalPagoComponent } from '../portal_pago/portal_pago.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import {MatStepperModule} from '@angular/material/stepper';



// @NgModule decorator with its metadata
@NgModule({
  declarations: [
   PropiedadesComponent,
    SolicitanteComponent,
    Tipos_certificadosComponent,
    CorviComponent,
    Resumen_certComponent, 
    FilterPipe3,
    Tabs_certComponent,
    PortalPagoComponent
     ],
  imports: [
    FormsModule,
    Ng9RutModule,
    NgxPaginationModule,
    CommonModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    FileUploadModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    NgxSpinnerModule,
    HttpClientModule
  ],

  exports: [
    PropiedadesComponent,
    SolicitanteComponent,
    Tipos_certificadosComponent,
    CorviComponent,
    Resumen_certComponent, 
    FilterPipe3,
    PortalPagoComponent,
    Tabs_certComponent  
  ]
})
export class Navbar_certModule { }